export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      title: true,
      name: 'Coach DV7',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Matches',
      url: '/matches',
      icon: 'icon-game-controller'
    },
    {
      name: 'Trainings',
      url: '/trainings',
      icon: 'icon-calculator'
    },
    {
      title: true,
      name: 'Admin DV7',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Teams',
      url: '/teams',
      icon: 'icon-people'
    },
    {
      name: 'Events',
      url: '/events',
      icon: 'icon-feed'
    },
    {
      name: 'News',
      url: '/news',
      icon: 'icon-book-open'
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-user'
    },
    // {
    //   title: true,
    //   name: 'Superadmin OWQLO',
    //   class: '',
    //   wrapper: {
    //     element: '',
    //     attributes: {}
    //   }
    // },
    // {
    //   name: 'Admins',
    //   url: '/users',
    //   icon: 'icon-user'
    // },

    
  ]
}
